export enum PortalLoginPerfResult {
  Success = 'success',
  Failed = 'failed'
}

export enum PortalLoginPerfMilestone {
  SendCodeToCodeScreen = 'sendCodeToCodeScreen',
  EnterCodeToDashboard = 'enterCodeToDashboard'
}

/** Temporary portal login perf document (portal_login_perf_logs). Remove after measurement window. */
export type PortalLoginPerfLogEntry = {
  createdAt: string
  dateKey: string
  flowId: string
  milestone: PortalLoginPerfMilestone
  result: PortalLoginPerfResult
  appVersion: string
  platform: 'web'
  userAgent: string
  routeFrom?: string
  sendCodeToCodeScreenMs?: number
  enterCodeToDashboardVisibleMs?: number
  requestPortalLoginSMSMs?: number
  sendVerificationCodeMs?: number
  verifyCodeConfirmMs?: number
  authStateResolveMs?: number
  setPortalUserClaimsMs?: number
  getEnrollmentUserByPhoneMs?: number
  dashboardDataReadyMs?: number
  retryCount?: number
  errorStage?: string
  errorCode?: string
}
